import { render, staticRenderFns } from "./Quefeed.vue?vue&type=template&id=2ef6b30a&scoped=true&"
import script from "./Quefeed.vue?vue&type=script&lang=js&"
export * from "./Quefeed.vue?vue&type=script&lang=js&"
import style0 from "./Quefeed.vue?vue&type=style&index=0&id=2ef6b30a&lang=css&scoped=true&"
import style1 from "./Quefeed.vue?vue&type=style&index=1&id=2ef6b30a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ef6b30a",
  null
  
)

export default component.exports